import {
  SMARTY_EMPTY_CLASS,
  smartyItemEntriesLinkCss,
} from "./utils/smartyAddressAutocompleteUi.js";

export const ADDRESS_AC_DROPDOWN_CLASS = "nm-address-ac-dropdown";
export const ADDRESS_AC_ITEM_CLASS = "nm-address-ac-item";
export const QUOTE_PLACES_DROPDOWN_CLASS = "nm-quote-places-dropdown";
export const QUOTE_PLACES_ITEM_CLASS = "nm-quote-places-item";
export const QUOTE_PLACES_SECTION_CLASS = "nm-quote-places-section";

/** Dropdown body + items — shared by Smarty address suggest menus. */
export const NM_ADDRESS_SUGGEST_DROPDOWN_CSS = `
  .${ADDRESS_AC_DROPDOWN_CLASS},
  .${QUOTE_PLACES_DROPDOWN_CLASS} {
    position: fixed;
    z-index: 2147483646;
    max-height: min(320px, 40vh);
    overflow-y: auto;
    box-sizing: border-box;
    margin: 0;
    padding: 0.375rem;
    display: grid;
    gap: 0.125rem;
    font-family: Inter, "Noto Sans", system-ui, sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: rgb(var(--slate-12, var(--text-primary)));
    background: rgba(var(--alpha-3, 255, 255, 255, 0.96)) !important;
    backdrop-filter: blur(100px);
    -webkit-backdrop-filter: blur(100px);
    border: 1px solid rgb(var(--border-weak, 234 234 234)) !important;
    outline: none;
    border-radius: 0.75rem;
    box-shadow: 0 1px 2px rgba(var(--black-alpha-1, 0, 0, 0, 0.12));
  }

  .${ADDRESS_AC_ITEM_CLASS},
  .${QUOTE_PLACES_ITEM_CLASS} {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    width: 100%;
    margin: 0;
    padding: 0.5rem 0.625rem;
    border: none;
    border-radius: var(--nm-radius, 0.5rem);
    background: transparent;
    color: rgb(var(--slate-12, var(--text-primary)));
    text-align: left;
    cursor: pointer;
    font: inherit;
    font-size: 0.875rem;
    line-height: 1.25rem;
    transition: background-color 100ms ease-out;
  }

  .${ADDRESS_AC_ITEM_CLASS}:hover,
  .${ADDRESS_AC_ITEM_CLASS}:focus,
  .${QUOTE_PLACES_ITEM_CLASS}:hover,
  .${QUOTE_PLACES_ITEM_CLASS}:focus {
    background: rgba(var(--alpha-2, 196, 197, 198, 0.22));
    outline: none;
  }

  .${QUOTE_PLACES_SECTION_CLASS} {
    padding: 0.375rem 0.625rem 0.125rem;
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: rgb(var(--slate-11, var(--text-secondary)));
    pointer-events: none;
  }

  .${QUOTE_PLACES_ITEM_CLASS}.${QUOTE_PLACES_ITEM_CLASS}--smarty {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  ${smartyItemEntriesLinkCss(ADDRESS_AC_ITEM_CLASS)}
  ${smartyItemEntriesLinkCss(QUOTE_PLACES_ITEM_CLASS)}

  .${SMARTY_EMPTY_CLASS} {
    padding: 0.625rem 0.75rem;
    color: rgb(var(--slate-11, var(--text-secondary)));
    text-align: left;
    cursor: default;
    pointer-events: none;
  }

  .${SMARTY_EMPTY_CLASS}__title {
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: rgb(var(--slate-12, var(--text-primary)));
  }

  .${SMARTY_EMPTY_CLASS}__hint {
    margin-top: 0.25rem;
    font-size: 0.75rem;
    line-height: 1.25rem;
    color: rgb(var(--slate-11, var(--text-secondary)));
  }
`;
